"use client";

import { BarChart3, Lock, Shield, Users } from "lucide-react";
import { useJsonTranslation } from "@/hooks/useJsonTranslation";

const items = [
  {
    icon: Shield,
    titleKey: "items.soc2.title",
    descKey: "items.soc2.description",
  },
  {
    icon: Lock,
    titleKey: "items.encryption.title",
    descKey: "items.encryption.description",
  },
  {
    icon: Users,
    titleKey: "items.privacy.title",
    descKey: "items.privacy.description",
  },
  {
    icon: BarChart3,
    titleKey: "items.uptime.title",
    descKey: "items.uptime.description",
  },
];

export function Trust() {
  const { t } = useJsonTranslation("HomeTrust");

  return (
    <div
      data-home-block="trust-grid"
      className="relative px-5 py-8 sm:px-7 sm:py-10"
    >
      <div>
        <div className="mb-10 text-center">
          <div className="home-eyebrow mb-4">
            {t("eyebrow")}
          </div>
          <h2 className="home-section-title text-3xl text-balance md:text-4xl">
            {t("title")}
          </h2>
          <p className="home-section-copy mx-auto mt-5 max-w-2xl text-lg text-pretty">
            {t("subtitle")}
          </p>
        </div>

        <div className="mx-auto grid max-w-5xl gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((item, i) => (
            <div
              key={i}
              className="uni-card group relative overflow-hidden text-center"
            >
              <div className="home-icon-tile mx-auto mb-5 h-12 w-12 transition-transform duration-300 group-hover:scale-105">
                <item.icon className="h-6 w-6" aria-hidden="true" />
              </div>
              <h3 className="font-display text-foreground mb-2 font-semibold">
                {t(item.titleKey)}
              </h3>
              <p className="home-section-copy text-sm">
                {t(item.descKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
